//Drafts.jsx

import React from 'react';
import DraftHoursReport from '@/components/data/hours/DraftsHoursReport';
import MondayDate from '@/components/data/date/MondayDate';

const Drafts = ({ data }) => {

  function processData(data) {
    return data.reduce((groups, item) => {
      const date = item.StartDate;
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(item);
      return groups;
    }, {});
  }

  return (
    <div>
      
      {data &&
        Object.entries(processData(data)).map(([date, report]) => (
          <div key={date}>
            <DraftHoursReport date={MondayDate.formatToUIDate(date)} report={report} />
          </div>
        ))}
    </div>
  );
};

export default Drafts;
